import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Msg, Dialog, Button } from 'react-weui';
import PropTypes from 'prop-types';
import Http from 'services/http2';
import User from 'services/user2';
import EnumService from 'services/enum2';
import * as MobileActions from 'actions/index.ts';
import { withStyles } from '@material-ui/core/styles';

import TopNav from '../components/topNav';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';

/* dev
http://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fmessage%2Fsetup&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/
const styles = theme => ({
  h5: {
    fontSize: 14,
    padding: '10px 15px 10px 20px',
    color: '#999999',
  },
  subUl: {
    backgroundColor: '#ffffff',
    padding: '0 15px 0 20px',
  },
  subLi: {
    display: 'block',
    height: 48,
    lineHeight: '48px',
    fontSize: 12,
  },
  subSwitch: {
    float: 'right',
  },
  pb70: {
    paddingBottom: 70,
  },
});

class MessageSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      error: null,
      cfgType: 0,
      paramList: [],
      subList: [],
      showSuc: false,
      style1: {
        title: '',
        buttons: [
          {
            type: 'primary',
            label: '好的',
            onClick: this.handleOK.bind(this),
          },
        ],
      },
    };
    this.companyCode = '';
    this.dialogMsg = '';
  }

  init() {
    User.init(this.companyCode).then(response => {
      if (response.success) {
        this.companyCode = User.getCompanyCode();
        this.getSysMsgConfig();
        this.setState({ inited: true });
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  // 消息列表权限
  getSysMsgConfig() {
    let postbody = {
      apiPath: '/archives/sysMsgConfig',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data || [];

        list.forEach(item => {
          EnumService.getValue('B01_Msg_Config_Type', item.cfgType).then(
            value => {
              item.cfgName = value;
              this.forceUpdate();
            }
          );
        });
        this.getUserMsgParams(list);
      }
    });
  }

  // 用户权限
  getUserMsgParams(list) {
    let postbody = {
      apiPath: '/archives/userMsgParams',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let len = response.data ? response.data.length : null;
        list.forEach(param => {
          param.subList.forEach(sub => {
            let num = 0;
            sub.subList.forEach(row => {
              row.authList.forEach(auth => {
                if (auth.selectFlag === 0 && auth.authName === '微信') {
                  row.isHide = true;
                  num += 1;
                }
                if (auth.selectFlag === 1 && auth.authName !== '微信') {
                  auth.paramValue = 1;
                } else if (len) {
                  response.data.forEach(item => {
                    if (auth.authCode === item.paramCode) {
                      auth.paramValue = item.paramValue;
                    }
                  });
                } else {
                  if (auth.authName === '邮件' || auth.authName === '微信') {
                    auth.paramValue = 1;
                  }
                }
              });
            });
            if (num === sub.subList.length) {
              sub.isHide = true;
            }
          });
        });
        let cfgType = list[0].cfgType;
        let subList = list[0].subList;
        this.setState({ paramList: list, cfgType: cfgType, subList: subList });
      }
    });
  }

  // 切换tab
  handleChange = (event, type) => {
    let subList = [];
    this.state.paramList.forEach(param => {
      if (param.cfgType === type) {
        subList = param.subList;
      }
    });
    this.setState({ cfgType: type, subList: subList });
  };

  getPostbody() {
    let allList = [];

    this.state.paramList.forEach(param => {
      param.subList.forEach(sub => {
        sub.subList.forEach(row => {
          row.authList.forEach(auth => {
            if (auth.paramValue) {
              allList.push({
                paramCode: auth.authCode,
                paramValue: 1,
                companyCode: this.companyCode,
              });
            }
          });
        });
      });
    });
    return {
      allList,
    };
  }

  saveUserParams = () => {
    let postbody = {
      ...this.getPostbody(),
      apiPath: '/archives/saveUserParams',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        this.dialogMsg = '设置成功!';
      } else {
        this.dialogMsg = response.errorMsg;
      }
      this.setState({ showSuc: true });
    });
  };

  handleOK() {
    this.setState({
      showSuc: false,
    });
  }

  render() {
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    const { classes } = this.props;
    const { cfgType, paramList, subList } = this.state;
    return (
      <div>
        <TopNav inited={this.state.inited} />
        <Paper square={true} style={{ marginBottom: '5px' }}>
          <Tabs
            value={cfgType}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleChange}
          >
            {paramList.map(
              (item, index) =>
                item.cfgType !== 30 && (
                  <Tab label={item.cfgName} key={index} value={item.cfgType} />
                )
            )}
          </Tabs>
        </Paper>
        <div className={classes.pb70}>
          {subList.map(
            item =>
              !item.isHide && (
                <div key={item.cfgCode}>
                  <h5 className={classes.h5}>{item.cfgName}</h5>
                  <div className={classes.subUl}>
                    {item.subList.map(
                      sub =>
                        !sub.isHide && (
                          <div key={sub.cfgCode} className={classes.subLi}>
                            <span>{sub.cfgName}</span>
                            {sub.authList.map(auth => (
                              <span key={auth.authCode}>
                                {auth.authName === '微信' && (
                                  <Switch
                                    checked={auth.paramValue === 1}
                                    className={classes.subSwitch}
                                    onChange={() => {
                                      auth.paramValue = auth.paramValue ? 0 : 1;
                                      this.setState({ subList: subList });
                                    }}
                                    value={auth.authCode}
                                    color="primary"
                                  />
                                )}
                              </span>
                            ))}
                          </div>
                        )
                    )}
                  </div>
                </div>
              )
          )}
        </div>

        <div className="wrap m-flex-box fixed-bottom">
          <Button
            type="default"
            onClick={this.saveUserParams}
            className="m-flex-item u-btn u-btn_primary"
          >
            保存设置
          </Button>
        </div>

        <Dialog
          type="ios"
          title={this.state.style1.title}
          buttons={this.state.style1.buttons}
          show={this.state.showSuc}
        >
          {this.dialogMsg}
        </Dialog>
      </div>
    );
  }
}

MessageSetup.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MessageSetup));
